/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgStatusErrorFull = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37zm113 1024 342-342-113-113-342 342-342-342-113 113 342 342-342 342 113 113 342-342 342 342 113-113-342-342z"
    }));
export default SvgStatusErrorFull;
